exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-bg h5 {\n  display: inline-block;\n}\n.about-title {\n  margin-bottom: 15px;\n}\ntextarea {\n  width: 100%;\n}\n.form-group h6 {\n  margin-bottom: 15px;\n}\n.dropdown-toggle::after {\n  display: none;\n}\n\n.card-header-text h6 {\n  margin: 0;\n  padding-top: 8px;\n}\np.error-msg {\n  position: absolute;\n  top: 45px;\n  right: 0;\n  padding: 10px;\n  border: 1px solid #ddd;\n  background: #fdcbcb;\n  border-radius: 20px;\n  margin: 0;\n  font-size: 10px;\n  color: #f00;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/extras/export-csv/export-csv.component.css
// module id = ../../../../../src/app/extras/export-csv/export-csv.component.css
// module chunks = main